document.addEventListener('DOMContentLoaded', function () {
    $('.shopify-section-header-sticky').css('position', 'unset');
    let target = $('.summer-promotion-nav').offset().top;
    $(window).scroll(function () {
      let scrollTop = $(window).scrollTop();
      if (scrollTop >= target) {
        $('.summer-promotion-nav').addClass('fix_top');
      } else if (scrollTop < target) {
        $('.summer-promotion-nav').removeClass('fix_top');
      }
    });
  
    let scroll_num = 100;
    if ($(window).width() < 768) {
      scroll_num = $('.summer-promotion-nav').innerHeight();
    }
    $('.summer-promotion-nav .nav-item').on('click', function (e) {
      e.stopPropagation();
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
      let targetclass = $(this).attr('href').slice(1);
      let targetheight = $(`.${targetclass}`).eq(0).offset().top - scroll_num;
      $('html,body').animate({ scrollTop: targetheight }, 300);
    });

  });
  
  